import React from "react";
import { Col, Row, Form, Card, Button, FormCheck, Container } from "@themesberg/react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import BgImage from "../../assets/img/illustrations/signin.svg";
import { useAuth } from "../../store/AuthContext";
import { FormProvider, useForm } from "react-hook-form";
import { Textbox } from "../../components/Textbox";
import { sendError, sendSuccess } from "../../helpers/Helper";
import { API_URL_ENDPOINT } from "../../appsetting";
import axios from "axios";
import { Routess } from "../../Routes/routes";

export const SignIn = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const methods = useForm();
  const { register, handleSubmit, reset, formState: { errors, isSubmitting }, watch } = methods;

  const onSubmit = async (param) => {
    try {
      const response = await axios.post(API_URL_ENDPOINT.Login, param, {
        headers: { "Content-Type": "application/json" },
      });

      if (response.data?.status) {
        await login(response.data?.data)
        reset();
        sendSuccess(response.data?.message);
        navigate("/");
      } else {
        sendError(response.data?.message || "Something went wrong");
      }
    } catch (ex) {
      sendError(ex.response?.data?.message || ex.message || "Something went wrong");
    }
  };

  return (
    <main>
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
          <Row className="justify-content-center form-bg-image" style={{ backgroundImage: `url(${BgImage})` }}>
            <Col xs={12} className="d-flex align-items-center justify-content-center">
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <div className="text-center text-md-center mb-4 mt-md-0">
                  <h3 className="mb-0">Sign In</h3>
                </div>
                <FormProvider {...methods}>
                  <Form className="mt-4" onSubmit={handleSubmit(onSubmit)}>
                    <Form.Group id="email-group" className="mb-4">
                      <Textbox
                        Label="Your Email"
                        name="email"
                        Placeholder="Enter Your Email"
                        validationRules={{ required: "Email is required" }}
                        register={register}
                        errors={errors}
                        watch={watch}
                      />
                    </Form.Group>
                    <Form.Group id="password-group" className="mb-4">
                      <Textbox
                        Label="Your Password"
                        Type="password"
                        name="password"
                        Placeholder="Enter Your Password"
                        validationRules={{ required: "Password is required" }}
                        register={register}
                        errors={errors}
                        watch={watch}
                      />
                    </Form.Group>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <Form.Check type="checkbox">
                        <FormCheck.Input id="remember-me" className="me-2" />
                        <FormCheck.Label htmlFor="remember-me" className="mb-0">Remember me</FormCheck.Label>
                      </Form.Check>
                      <Card.Link as={Link} to={Routess.Forgot.path} className="small text-end">Lost password?</Card.Link>
                    </div>
                    <Button variant="primary" disabled={isSubmitting} type="submit" className="w-100">
                      {isSubmitting ? "Signing in..." : "Sign in"}
                    </Button>
                  </Form>
                </FormProvider>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};
